export default __webpack_public_path__ + "static/media/profil1.12867026.png";